import { appGo } from "@/app/navigate";
import { planHref } from "@/shell/project-nav";
import { useProjectStore } from "@/store/project-store";
import type { ActivityEvent } from "./activity-model";

export function activityPath(planId?: string | null): string {
  return planId ? planHref(planId, "activity") : "/activity";
}

export function planDestinationForKind(kind: ActivityEvent["kind"], target?: ActivityEvent["target"]): string {
  if (kind === "issue" || target?.type === "record") return "records";
  if (kind === "document" || target?.type === "document") return "docs";
  if (kind === "baseline" || target?.type === "baseline") return "schedule";
  if (kind === "schedule" || target?.type === "weekly") return "weekly";
  return "tasks";
}

/** 활동 한 줄에서 그 작업·이슈·문서·보고로 간다. */
export function openActivity(event: ActivityEvent): void {
  const target = event.target;
  if (target.type === "document") {
    appGo(planHref(event.planId, `docs/${target.documentId}`));
    return;
  }
  if (target.type === "weekly") {
    appGo(planHref(event.planId, "weekly"));
    return;
  }
  if (target.type === "baseline") {
    appGo(planHref(event.planId, "schedule"));
    return;
  }
  const store = useProjectStore.getState();
  if (store.activeId !== event.planId && !store.openProject(event.planId)) {
    appGo(planHref(event.planId, target.type === "record" ? "records" : "tasks"));
    return;
  }
  if (target.type === "task") {
    useProjectStore.getState().setExecutionFocus(target.taskId, {
      tab: target.commentId ? "comments" : "details",
      commentId: target.commentId,
    });
    return;
  }
  useProjectStore.getState().setRecordFocus(target.recordId, {
    tab: target.commentId ? "comments" : "details",
    commentId: target.commentId,
  });
}
